export const rolesObj = {
    ADMIN: "ADMIN",
    CUSTOMER: "CUSTOMER",
    SUBADMIN: "SUBADMIN",
    WHOLESALER: "WHOLESALER",
    RETAILER: "RETAILER",
};
export const discountStatus = {
    PERCENTAGE: "PERCENTAGE",
    FLATOFF: "FLATOFF",
};